import { render, staticRenderFns } from "./FieldBasicData.vue?vue&type=template&id=aa0ea4b6&"
import script from "./FieldBasicData.vue?vue&type=script&lang=ts&"
export * from "./FieldBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports